import React, { useEffect, useRef, useState } from "react";
// import { toast } from "react-hot-toast";
import { Form } from "react-router-dom";
import axios from "../../API/axios";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import CreatableSelect from "react-select/creatable";
import { debounce, set } from "lodash";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { customStyles } from "../../selectStyles";
import { findSelectOption, resolveOrgUid, seedSelectOptions } from "../../utility/selectFieldHelpers";
import Flatpickr from 'react-flatpickr';
import { resume } from "../../config/imagesLink";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { Button, Overlay, Popover } from "react-bootstrap";
import { Input } from "reactstrap";
import DeleteOutlineSharpIcon from '@mui/icons-material/DeleteOutlineSharp';
import { useTranslation } from "react-i18next";
import useEscapeKeyDown from "../../hooks/useEscapeKeyDown";

const ProfileCertificateUpdate = ({
  showCertificateUpdate,
  handleUpdateCertificateClose,
  getUserProfile,
  certificateData
}) => {
  const { t } = useTranslation();
  useEscapeKeyDown(showCertificateUpdate, handleUpdateCertificateClose);

  const sessionId = localStorage.getItem("sessionId");
  const [cerName, setCerName] = useState("");
  const [recognition, setRecognition] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [present, setPresent] = useState(false);
  const [endDate, setEndDate] = useState(null);
    const UserCcv = localStorage.getItem("UserCcv");

  const isCertificationDateRangeInvalid =
    Boolean(startDate) &&
    Boolean(endDate) &&
    moment(endDate).isBefore(moment(startDate), "day");
  const [description, setDescription] = useState("");
  const [credentialId, setCredentialId] = useState("");
  const [orgType, setOrgType] = useState("");
  // const [orgName, setOrgName] = useState("");
  const language = localStorage.getItem("Lang");
  const [cityData, setCityData] = useState([]);
  const [cityId, setCityId] = useState(null);
  const [citySearch, setCitySearch] = useState(null);

  const [display, setDisplay] = useState(false);

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const [valueC, setValueC] = useState(null);
  const [pageC, setPageC] = useState(0);
  const [typeC, setTypeC] = useState("");
  const [isLoadingC, setIsLoadingC] = useState(false);
  const [optionsC, setOptionsC] = useState([]);
  const [totalPagesCom, setTotalPagesCom] = useState(0);
  const logValueC = debounce((typeC) => {
    setTypeC(typeC);
  }, 250);

  console.log("certificateData", certificateData);

  const [valueIns, setValueIns] = useState(null);
  const [pageIns, setPageIns] = useState(0);
  const [typedIns, setTypedIns] = useState("");
  const [optionsIns, setOptionsIns] = useState([]);
  const [totalPagesIns, setTotalPagesIns] = useState(0);
  const logValueIns = debounce((typedIns) => {
    setTypedIns(typedIns);
  }, 250);

  const [orgData, setOrgData] = useState([]);
  const [orgId, setOrgId] = useState('');
  const getOrgType = () => {

    axios
      .get(`Master/GetOrgTypesDDL?LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        console.log("setOrgData", res);
        const data = res.map((item) => ({ value: item.id, label: item.name }));
        setOrgData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getOrgType();
  }, []);
  const [getOrgInsTId, setGenOrgInstId] = useState('')
  const [newOrgType, setnewOrgType] = useState(null);
  const UpdateCertification = async () => {
    setDisplay(true);
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      name: cerName,
      recognition: recognition,
      issuingOrgType: orgType === '' ? 4 : orgType,
      orgId: valuegnr === null ? JSON.stringify(getOrgInsTId) : valuegnr,
      credentialId: credentialId,
      description: description,
      locationId: null,
      cityId: cityId,
      issueDate: startDate === "" ? "" : moment(startDate).format("YYYY-MM-DD"),
      isExpirable: present,
      expirationDate:
        endDate === null  ? null : moment(endDate).format("YYYY-MM-DD"),
      userCrtfctnId: certificateData.userCrtfctnId,
      langKey: language === "en" ? "" : language,
      isSynced: sync

    };
    console.log(data);
    if (!cerName || !cityId || !recognition || !credentialId || !startDate || (present && !endDate)) {
      setErrorToastMessage(t("modals.Please fill all the required fields"));
      setShowErrorToast(true);
      return;
    }

    if (present && isCertificationDateRangeInvalid) {
      setErrorToastMessage("Expiration date cannot be earlier than issue date.");
      setShowErrorToast(true);
      return;
    }

    try {
      await axios
        .put(`UserData/UpdateCertificationInfo`, data)
        .then((resData) => {
          console.log("resData cert", resData);
          //   toast.success(resData.data.message);
          setToastMessage(resData.data.message);
          setShowToast(true);
          getUserProfile();
          handleUpdateCertificateClose();
          //   addReset();
        });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.title);
        setShowErrorToast(true);
      }
    }
  };
  useEffect(() => {
    if (
      startDate &&
      endDate &&
      moment(endDate).isBefore(moment(startDate), "day")
    ) {
      setEndDate(null);
    }
  }, [startDate, endDate]);

  const Companies = () => {
    setIsLoadingC(true);
    axios
      .get(
        `Master/GetCompaniesDDL?search=${typeC}&pageNumber=${pageC + 1
        }&pageSize=100&LangKey=${language}&DeviceType=Web`
      )
      .then((response) => {
        console.log(response);
        const data = response?.data?.responseData?.orgList.map((item) => ({
          value: item.uiDno,
          label: item.name,
        }));
        setPageC((prevPage) => prevPage + 1);
        setIsLoadingC(false);
        setOptionsC((prevOptions) => [...prevOptions, ...data]);
        setTotalPagesCom(response.data.paging.totalPages);
      })
      .catch((error) => {
        console.log(error);
        setIsLoadingC(false);
      });
  };

  const handleOpenC = () => {
    setPageC(1);
  };

  const handleChangeC = (value) => {
    setValueC(value.value);
    setPageC(0);
  };

  const handleInputChangeC = (typed) => {
    logValueC(typed);
    if (!typed) setPageC(0);
  };

  const handleMenuScrollToBottomC = () => {
    if (pageC < totalPagesCom) {
      Companies();
    }
  };

  const renderOptionC = ({
    focusedOption,
    focusOption,
    key,
    labelKey,
    option,
    selectValue,
    style,
    valueArray,
  }) => {
    // Your rendering logic here
  };

  useEffect(() => {
    if (typeC) {
      Companies();
    }
  }, [typeC]);

  const addOptionsIns = () => {
    axios
      .get(
        `Master/GetInstitutionsDDL?search=${typedIns}&pageNumber=${pageIns + 1
        }&pageSize=100&LangKey=${language}`
      )
      .then((response) => {
        console.log(response.data.responseData.orgList);
        const data = response.data.responseData.orgList.map((item) => ({
          value: item.uiDno,
          label: item.name,
        }));
        setPageIns((prevPage) => prevPage + 1);
        setOptionsIns((prevOptions) => [...prevOptions, ...data]);
        setTotalPagesIns(response.data.responseData.paging.totalPages);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleOpenIns = () => {
    setPageIns(1);
  };

  const handleChangeIns = (valueIns) => {
    if (valueIns) {
      setValueIns(valueIns.value);
    } else {
      setValueIns(""); // or handle the clear case appropriately
    }

    setPageIns(0);
  };

  const handleInputChangeIns = (typedIns) => {
    logValueIns(typedIns);
    if (!typedIns) setPageIns(0);
  };

  const handleMenuScrollToBottomIns = () => {
    if (pageIns < totalPagesIns) {
      addOptionsIns();
    }
  };

  const renderOptionIns = ({
    focusedOption,
    focusOption,
    key,
    labelKey,
    option,
    selectValue,
    style,
    valueArray,
  }) => {
    // Your rendering logic here
  };

  useEffect(() => {
    if (typedIns) {
      addOptionsIns();
    }
  }, [typedIns]);

  const [valuegnr, setValuegnr] = useState(null);
  const [pagegnr, setPagegnr] = useState(0);
  const [typedgnr, setTypedgnr] = useState("");
  const [optionsgnr, setOptionsgnr] = useState([]);
  const [totalPagesgnr, setTotalPagesgnr] = useState(0);
  const logValuegnr = debounce((typedgnr) => {
    setTypedgnr(typedgnr);
  }, 250);
  console.log("typed", valuegnr, typedgnr);
    const [sync, setSync] = useState(false);

  const addOptionsgnr = () => {
    axios
      .get(
        `Master/GetAllOrganizationsDDL?search=${typedgnr}&pageNumber=${pagegnr + 1
        }&pageSize=100&DeviceType=Web&LangKey=${language}`
      )
      .then((response) => {
        console.log('response.data.responseData.orgList', response.data.responseData.list);

        const data = response.data.responseData.list.map((item) => ({

          value: item.uiDno,
          label: item.name,
          typeId: item.typeId,
          isOrgVrfd: item.isVerified,
          isOrgRgd: item.isRgstrd,
        }));
        setPagegnr((prevPage) => prevPage + 1);
        setOptionsgnr((prevOptions) => [...prevOptions, ...data]);
        setTotalPagesgnr(response.data.responseData.paging.totalPages);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleOpengnr = () => {
    setPagegnr(1);
  };

  const handleChangegnr = (valuegnr) => {
    if (valuegnr) {
      setValuegnr(valuegnr.value);
      setOrgType(valuegnr.typeId)
    } else {
      setValuegnr(""); // or handle the clear case appropriately
      setOrgType("")
    }

    setPagegnr(0);
  };

  const handleInputChangegnr = (typedgnr) => {
    logValuegnr(typedgnr);
    if (!typedgnr) setPagegnr(0);
  };

  const handleMenuScrollToBottomgnr = () => {
    if (pagegnr < totalPagesgnr) {
      addOptionsgnr();
    }
  };

  const renderOptiongnr = ({
    focusedOption,
    focusOption,
    key,
    labelKey,
    option,
    selectValue,
    style,
    valueArray,
  }) => {
    // Your rendering logic here
  };

  useEffect(() => {
    if (typedgnr) {
      addOptionsgnr();
    }
  }, [typedgnr]);

  const getCity = () => {
    axios
      .get(`Master/GetCitiesDDL?search=${citySearch}&LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.cityId,
          label: item.cityName,
        }));
        setCityData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    if (citySearch) {
      getCity();
    }
  }, [citySearch]);


  // useEffect(() => {
  //   if (showCertificateUpdate) {
  //     document.body.style.overflow = 'hidden';
  //     document.documentElement.style.overflow = 'hidden';
  //     document.body.classList.add('modal-open'); // When a modal opens
  //   } else {
  //     document.body.style.overflow = 'unset';
  //     document.documentElement.style.overflow = '';
  //     document.body.classList.remove('modal-open'); // When a modal closes
  //   }
  // }, [showCertificateUpdate]);


  useEffect(() => {
    if (certificateData) {
      setCerName(certificateData?.name);
      setRecognition(certificateData?.recognition);
      setCredentialId(certificateData?.credentialId)
      setStartDate(certificateData.issueDate ? moment(certificateData.issueDate).toDate() : null);
      setEndDate(certificateData.expirationDate ? moment(certificateData.expirationDate).toDate() : null);
      setDescription(certificateData?.description);
      setOrgId(certificateData?.issuingOrgType);
      setOrgType(certificateData?.issuingOrgType)
      setCityId(certificateData?.cityId);
      setCitySearch(certificateData?.cityName)
      setTypeC(certificateData?.orgId)
      setValueC(certificateData?.orgId)
      const orgValue = resolveOrgUid(certificateData);
      setValuegnr(orgValue)
      setTypedgnr(certificateData?.orgName)
      setPageC(0)
      setPageIns(0)
      setPagegnr(0)
      if (certificateData?.orgName && orgValue) {
        setOptionsgnr(seedSelectOptions(orgValue, certificateData.orgName, {
          typeId: certificateData.issuingOrgType,
          isOrgVrfd: certificateData.isOrgVrfd,
          isOrgRgd: certificateData.isOrgRgd,
        }));
      }
      if (certificateData?.cityId && certificateData?.cityName) {
        setCityData(seedSelectOptions(certificateData.cityId, certificateData.cityName));
      }
    }
  }, [certificateData]);
  const preventYearScroll = (datePickerInstance) => {
    const yearElement = datePickerInstance.currentYearElement;
    if (yearElement) {
      yearElement.addEventListener("wheel", (e) => {
        e.preventDefault(); // Stops mouse scroll
      });
    }
  };
  console.log('optionsgnr', optionsgnr, valuegnr);

  const [showTooltip, setShowTooltip] = useState(false);
  const [OrganizationName, setOrganizationName] = useState("");
  const [InsName, setInsName] = useState("");
  const targetRef = useRef(null);
  const toggleTooltip = () => {
    console.log("Toggling Tooltip");
    setShowTooltip((prev) => !prev);
  };

  const handleCloseNewOrg = (e) => {
    e?.preventDefault?.();
    setInsName("");
    setOrganizationName("");
    setGenOrgInstId("");
    setnewOrgType(null);
    setValuegnr(null);
    setOrgType("");
    setFileName("");
  };

  const [fileName, setFileName] = useState(""); // State to store selected filename
  const handleFileChange = (event) => {
    const file = event.target.files[0]; // Get the selected file
    if (file) {
      setFileName(file.name); // Set the filename in state
    }
  };



  const [orgCity, setOrgCity] = useState(null);
  const handleSaveInstitution = async () => {
    // setDisplay(true);

    // const formData = new FormData();
    // formData.append("orgName", OrganizationName);
    // formData.append("OrgType", "UnRegdInstitution");
    // formData.append("CityID", orgCity);
    // formData.append("OrgLogo", fileName);
    // formData.append("sessionId", sessionId);
    // console.log("formData", formData);

    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      gnrlOrgName: OrganizationName,
      type: 3,
      cityId: cityId,
      logoImage: fileName,
      locationId: null,
      langKey: language === "en" ? "" : language,
    }

    try {
      const res = await axios.post("/General/AddGeneralOrgByUser", data);
      console.log("resposne new", res);
      setGenOrgInstId(res.data.responseData.id);
      setnewOrgType(res.data.responseData.value);
      setInsName(res.data.responseData.value);
      // toast.success(res.data.message);
      setShowTooltip(false);
      setOrganizationName("");
      setOrgCity(null);
      setFileName("");
    } catch (error) {
      if (error.response && error.response.status === 404) {
        // toast.warning(error.response.data.message);
      } else {
        // toast.error(error.response?.data?.message || "An error occurred");
      }
    }
  };

  // //************************Enable Certification  ************************//
  // const [status, setStatus] = useState('')
  // const EnableCertification = async (Id) => {
  //   const responseData = {
  //     deviceType: "Web",
  //     sessionId: sessionId,
  //     id: Id,
  //   };
  //   try {
  //     await axios
  //       .put(`UserData/EnableCertificationInfo`, responseData)
  //       .then((res) => {
  //         setToastMessage(res.data.message);
  //         setShowToast(true);
  //         // getUserProfile();
  //         setStatus(1)
  //       });
  //   } catch (error) {
  //     console.log(error.response.data.message);
  //     if (error.response && error.response.status === 404) {
  //       setWarningToastMessage(error.response.data.message);
  //       setShowWarningToast(true);
  //     } else {
  //       setErrorToastMessage(error.response.data.message);
  //       setShowErrorToast(true);
  //     }
  //   }
  // };
  // //************************Enable Certification End  ************************//
  // //************************Disable Certification  ************************//
  // const DisableCertification = async (Id) => {
  //   const responseData = {
  //     deviceType: "Web",
  //     sessionId: sessionId,
  //     id: Id,
  //   };
  //   try {
  //     await axios
  //       .put(`UserData/DisableCertificationInfo`, responseData)
  //       .then((res) => {
  //         setToastMessage(res.data.message);
  //         setShowToast(true);
  //         // getUserProfile();
  //         setStatus(0)
  //       });
  //   } catch (error) {
  //     console.log(error.response.data.message);
  //     if (error.response && error.response.status === 404) {
  //       setWarningToastMessage(error.response.data.message);
  //       setShowWarningToast(true);
  //     } else {
  //       setErrorToastMessage(error.response.data.message);
  //       setShowErrorToast(true);
  //     }
  //   }
  // };
  // //************************Disable Certification End  ************************//

  // //************************Remove Certificate End  ************************//

  // const [showCertificateDelete, setShowCertificateDelete] = useState(false);
  // const handleRemoveCertificateClose = () => {
  //   setShowCertificateDelete(false);
  // };

  // const [certificateId, setCertificateId] = useState("");
  // const removeCertificate = async () => {
  //   handleRemoveCertificateCloseconst responseData = {
  //     deviceType: "Web",
  //     sessionId: sessionId,
  //     id: certificateId,
  //     // skllId: skillId
  //   };
  //   try {
  //     await axios
  //       .delete(`UserData/DeleteCertificationInfo`, { data: responseData })
  //       .then((res) => {
  //         setShowCertificateDelete(!showCertificateDelete);
  //         // toast.success(res.data.message);
  //         setToastMessage(res.data.message);
  //         setShowToast(true);
  //         getUserProfile();
  //       });
  //   } catch (error) {
  //     if (error.response && error.response.status === 404) {
  //       setWarningToastMessage(error.response.data.message);
  //       setShowWarningToast(true);
  //     } else {
  //       setErrorToastMessage(error.response.data.message);
  //       setShowErrorToast(true);
  //     }
  //   }
  // };

  // //************************Remove Certificate End  ************************//

  //   useEffect(() => {
  //   let scrollY = 0;

  //   if (showCertificateUpdate) {
  //     scrollY = window.scrollY;

  //     // Lock scroll
  //     document.body.style.position = 'fixed';
  //     document.body.style.top = `-${scrollY}px`;
  //     document.body.style.left = '0';
  //     document.body.style.right = '0';
  //     document.body.style.overflow = 'hidden';
  //     document.documentElement.style.overflow = 'hidden'; // 🛠️ Add this line
  //     document.body.classList.add('modal-open');
  //   } else {
  //     // Unlock scroll
  //     const scrollYValue = document.body.style.top;
  //     document.body.style.position = '';
  //     document.body.style.top = '';
  //     document.body.style.left = '';
  //     document.body.style.right = '';
  //     document.body.style.overflow = '';
  //     document.documentElement.style.overflow = ''; // 🛠️ Add this line
  //     document.body.classList.remove('modal-open');

  //     window.scrollTo(0, parseInt(scrollYValue || '0') * -1);
  //   }
  // }, [showCertificateUpdate]);

  useEffect(() => {
    let scrollY = 0;

    if (showCertificateUpdate) {
      // Save current scroll position
      scrollY = window.scrollY;
      document.body.dataset.scrollY = scrollY; // store in dataset

      // Lock scrolling
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      document.body.classList.add('modal-open');
    } else {
      // Unlock scrolling
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      document.body.classList.remove('modal-open');

      // Restore scroll position
      const storedY = document.body.dataset.scrollY || "0";
      window.scrollTo(0, parseInt(storedY, 10));
    }
  }, [showCertificateUpdate]);

  const modalContentRef = useRef(null);

  return (
    <>
      {showCertificateUpdate && (
        <div
          className="modal fade show modal-lg"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content" ref={modalContentRef}>
              <div className="setting-header d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <h6 className="mb-0 me-3">{t("User Profile.Update Certification")}</h6>
                  {/* <div className="form-switch form-check-primary ms-2">
                    <Input
                      type="switch"
                      defaultChecked={certificateData?.status === 1 || status === 1}
                      name="icon-primary"
                      onClick={() => {
                        if (certificateData?.status === 1 || status === 1) {
                          DisableCertification(certificateData.userCrtfctnId);
                        } else {
                          EnableCertification(certificateData.userCrtfctnId);
                        }
                      }}
                      className=""
                    />
                  </div>
                  <DeleteOutlineSharpIcon
                    className="material-symbols-sharp pointer delete-icon"
                    onClick={() => {
                      setShowCertificateDelete(!showCertificateDelete);
                      setCertificateId(certificateData.userCrtfctnId);
                    }}
                  /> */}
                </div>

                <CloseSharpIcon
                  className="material-symbols-sharp pointer"
                  onClick={() => {
                    handleUpdateCertificateClose();
                  }}
                />
              </div>
              <Form>
                <div className="row modal-p settings CreateCompany">
                  <div className="col-md-6 mt-2">
                    <label htmlFor="about" className="wlj-edu-field-label">
                      {t("User Profile.Certificate Name")}
                      <span className="text-danger ms-2">*</span>
                    </label>
                    <input
                      type="text"
                      className="GradeFieldEducation"
                      defaultValue={cerName}
                      onChange={(e) => setCerName(e.target.value)}
                      invalid={display && cerName === ""}
                    />
                    {display && !cerName ? (
                      <span className="error_msg_lbl">
                        {t("User Profile.Enter Certificate Name")}
                        {" "}
                      </span>
                    ) : null}
                  </div>

                  <div className="col-md-6 mt-2">
                    <div className="wlj-edu-label-row d-flex align-items-center flex-wrap">
                      <label htmlFor="about" className="mb-0">
                        {t("User Profile.Organization")}
                        <span className="text-danger ms-2">*</span>
                      </label>
                      {InsName !== "" ? (
                        <a
                          href="#"
                          onClick={handleCloseNewOrg}
                          className="createModal f-14 ms-2"
                        >
                          {t("User Profile.Close")}
                        </a>
                      ) : (
                        <a
                          href="#"
                          ref={targetRef}
                          onClick={(e) => {
                            e.preventDefault();
                            toggleTooltip();
                          }}
                          className="createModal f-14 ms-2"
                        >
                          {t("User Profile.Create New")}
                        </a>
                      )}
                    </div>
                    <Overlay
                      target={targetRef.current}
                      show={showTooltip}
                      placement="bottom"
                      rootClose
                      container={document.querySelector(".modal")}
                      onHide={() => setShowTooltip(false)} // Close when clicking outside
                    >
                      <Popover id="popover-basic">
                        <Popover.Header as="h3" className="Dark-Body-Card-group">{t("modal.Create Organization")}</Popover.Header>
                        <Popover.Body className="Dark-Body-Card-group">
                          <Form>
                            <div>
                              <label className="mb-1 Text-mb-Create">{t("modals.Organization Name")}</label>
                              <input
                                type="text"
                                value={OrganizationName}
                                onChange={(e) => setOrganizationName(e.target.value)}
                                placeholder={t("User Profile.Enter Org name")}
                                className="mb-2 form-control Dark-Input-from-group"
                              />
                            </div>
                            <div>
                              <label className="mb-1 Text-mb-Create">{t("User Profile.City")}</label>
                              <Select
                                defaultValue={cityId}
                                onChange={(selectedOption) =>
                                  setCityId(selectedOption.value)
                                }
                                options={cityData}
                                placeholder={t("modals.Search and Select City")}
                                onInputChange={(inputValue) => {
                                  setCitySearch(inputValue);

                                }}
                                invalid={display && cityId === ""}
                                styles={customStyles}
                              />
                            </div>
                            <div className=" mt-2 mb-2 Text-mb-Create">
                              <label className="mb-1">{t("User Profile.Institute logo")}</label>
                              <input
                                type="file"
                                id="lastName"
                                // className="form-control Dark-Input-from-group"
                                placeholder=""
                                onChange={handleFileChange}
                              //   onChange={(e) => {
                              //     handleProfileImageChange(e);
                              //   }}
                              //   invalid={displays && profileImage === ""}
                              />
                              {/* {displays && !profileImage ? (
                          <span className="error_msg_lbl text-red">
                            Upload Image{" "}
                          </span>
                        ) : null} */}
                            </div>
                            <div className="d-flex justify-content-end">
                              <button
                                type="button"
                                className="closebtn me-2 ms-3"
                                onClick={() => {
                                  setShowTooltip(false);
                                  setOrganizationName("");
                                }}
                                style={{ width: "50px", height: "30px" }}
                              >
                                {t("User Profile.Close")}
                              </button>

                              <button
                                type="button"
                                className="mainBtn"
                                onClick={handleSaveInstitution}
                                style={{ height: "30px !important", padding: '0px 11px' }}
                              >
                                {t("Newsfeed.Saved")}
                              </button>
                            </div>
                          </Form>
                        </Popover.Body>
                      </Popover>
                    </Overlay>
                    {InsName !== "" ? (
                      <div className="d-flex align-items-center wlj-org-selected-row">
                        <input
                          type="text"
                          value={InsName}
                          placeholder={t("User Profile.Enter Org name")}
                          className="mb-2 form-control"
                          disabled
                        />
                        <CloseSharpIcon
                          className="material-symbols-sharp pointer ms-2 mb-2"
                          onClick={handleCloseNewOrg}
                          title={t("User Profile.Close")}
                        />
                      </div>
                    ) : (
                    <Select
                      value={findSelectOption(optionsgnr, valuegnr)}
                      options={optionsgnr}
                      onOpen={handleOpengnr}
                      onChange={handleChangegnr}
                      onMenuScrollToBottom={handleMenuScrollToBottomgnr}
                      onInputChange={handleInputChangegnr}
                      styles={customStyles}
                      isClearable
                      className="iconsDropdown"
                      classNamePrefix="react-select"
                      //   onCreateOption={(newOption) => {
                      //     handleOpenCreateUserAward();
                      //     handleCloseUserAward()
                      //     addReset()
                      //   }}
                      placeholder={t("User Profile.Search and Select Org")}
                      formatOptionLabel={(option) => (
                        <div>
                          {option.label}

                          {option.isOrgVrfd === true ? (
                            <img src={resume.verified} width={15} className="ms-1" />
                          ) : option.isOrgRgd === true ? (
                            <img src={resume.register} width={15} className="ms-1" />
                          ) : (
                            <img src={resume.unregister} width={15} className="ms-1" />
                          )}
                        </div>
                      )}
                    />
                    )}
                    {display && !valuegnr && !getOrgInsTId ? (
                      <span className="error_msg_lbl">
                        {t("User Profile.Please Select Organization Type")}
                        {" "}
                      </span>
                    ) : null}
                  </div>


                  <div className="col-md-6 mt-2">
                    <label htmlFor="about">
                      {t("User Profile.Recognition")}
                      <span className="text-danger ms-2">*</span>
                    </label>
                    <input
                      type="text"
                      className="GradeFieldEducation"
                      defaultValue={recognition}
                      onChange={(e) => setRecognition(e.target.value)}
                      invalid={display && recognition === ""}
                    />
                    {display && !recognition ? (
                      <span className="error_msg_lbl">{t("User Profile.Enter Recognition")} </span>
                    ) : null}
                  </div>

                  <div className="col-md-6 mt-2">
                    <label htmlFor="about">
                      {t("User Profile.Credential Id")}
                      <span className="text-danger ms-2">*</span>
                    </label>
                    <input
                      type="text"
                      className="GradeFieldEducation"
                      defaultValue={credentialId}
                      onChange={(e) => setCredentialId(e.target.value)}
                      invalid={display && credentialId === ""}
                    />
                    {display && !credentialId ? (
                      <span className="error_msg_lbl">
                        {t("User Profile.Enter Credential Id")}
                        {" "}
                      </span>
                    ) : null}
                  </div>

                  <div className="col-md-6 mt-2">
                    <label htmlFor="about">
                      {t("User Profile.City")}
                      <span className="text-danger ms-2">*</span>
                    </label>
                    {/* <Select
                      defaultValue={cityId}
                      onChange={(selectedOption) =>
                        setCityId(selectedOption.value)
                      }
                      options={cityData}
                      placeholder={t("modals.Search and Select City")}
                      onInputChange={(inputValue) => {
                        setCitySearch(inputValue);
                      }}
                      invalid={display && cityId === ""}
                    /> */}
                    <Select
                      value={findSelectOption(cityData, cityId)}
                      className="dropdownBorder"
                      onChange={(selectedOption) =>
                        setCityId(selectedOption.value)
                      }
                      options={cityData}
                      placeholder={t("modals.Search and Select City")}
                      onInputChange={(inputValue) => {
                        setCitySearch(inputValue);
                      }}
                      invalid={display && cityId === ""}
                      styles={customStyles}
                      classNamePrefix="react-select"
                    />
                    {display && !cityId ? (
                      <span className="error_msg_lbl">{t("User Profile.Please Select City")} </span>
                    ) : null}
                  </div>


                  <div className="col-md-12 mt-2 d-flex align-items-center wlj-is-present-row">
                    <label htmlFor="cert-update-is-expirable" className="mb-0">{t("User Profile.Is Expirable")}</label>
                    <input
                      id="cert-update-is-expirable"
                      type="checkbox"
                      style={{ width: "20px", height: '20px', marginLeft: '5px' }}
                      //   id={`check-${item.id}`}
                      //   checked={selectedWorkLevelList.includes(item.id)}
                      onChange={() => setPresent(!present)}
                    />
                  </div>
                  <div className="col-md-6 mt-2">
                    <label htmlFor="about">
                      {t("User Profile.Issue Date")}
                      <span className="text-danger ms-2">*</span>
                    </label>

                    <Flatpickr className='form-control GradeFieldEducation pb-0' value={startDate} onChange={date => setStartDate(date[0] || null)} id='dob' options={{
                      maxDate: "today", // Disables future dates
                      onReady: (selectedDates, dateStr, instance) => {
                        preventYearScroll(instance); // Call the function to stop scroll on year
                      },
                      onOpen: (selectedDates, dateStr, instance) => {
                        preventYearScroll(instance); // Also prevent scroll when the picker opens
                      },
                    }} />
                    {display && !startDate ? (
                      <span className="error_msg_lbl">
                        {t("User Profile.Please Select Issue Date")}
                        {" "}
                      </span>
                    ) : null}
                  </div>
                  {present === true ?
                    <div className="col-md-6 mt-2">
                      <label htmlFor="about">
                        {t("User Profile.Expiration Date")}
                        <span className="text-danger ms-2">*</span>
                      </label>

                      <Flatpickr className='form-control' value={endDate} onChange={date => setEndDate(date[0] || null)} id='dob' options={{
                        minDate: startDate || undefined,
                        onReady: (selectedDates, dateStr, instance) => {
                          preventYearScroll(instance); // Call the function to stop scroll on year
                        },
                        onOpen: (selectedDates, dateStr, instance) => {
                          preventYearScroll(instance); // Also prevent scroll when the picker opens
                        },
                      }} />
                      {display && !endDate ? (
                        <span className="error_msg_lbl">
                          {t("User Profile.Please Select Expiration Date")}
                          {" "}
                        </span>
                      ) : null}
                      {present && isCertificationDateRangeInvalid ? (
                        <span className="error_msg_lbl">
                          Expiration date cannot be earlier than issue date.
                        </span>
                      ) : null}
                    </div>
                    : ''}

                  <div className="col-md-12 mt-2">
                    <label htmlFor="about">
                      {t("User Profile.Description")}
                      {/* <span className="text-danger ms-2">*</span> */}
                    </label>
                    <textarea
                      id="about"
                      name="about"
                      rows="4"
                      cols="50"
                      defaultValue={description}
                      onChange={(e) => setDescription(e.target.value)}
                    // invalid={display && description === ""}
                    ></textarea>
                    {/* {display && !description ? (
                      <span className="error_msg_lbl">Enter Description </span>
                    ) : null} */}
                  </div>

                  <div className="col-md-12 text-end mt-4">
                    <div className="d-flex align-items-center justify-content-end">
                     
                      {UserCcv === "Active" && <>
                        <input
                          type="checkbox"
                          style={{ width: "20px", height: "20px", marginRight: "5px" }}
                          onChange={() => setSync(!sync)}
                          checked={sync}
                        />
                      <label htmlFor="about">
                        {t("User Profile.Sync With Resume")}
                      </label>
                      </>}
                    <button
                      type="button"
                      className="closebtn me-2 ms-3"
                      onClick={handleUpdateCertificateClose}
                      style={{ width: "70px" }}
                    >
                      {t("User Profile.Close")}
                    </button>
                    <button
                      type="button"
                      className="mainBtn1"
                      onClick={UpdateCertification}
                      style={{
                        // Huzaifa Changes
                        // width: "107px" 
                        minWidth: "107px"
                        // Huzaifa Changes

                      }}
                    >
                      {t("Newsfeed.Update")}
                    </button>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
      {/* {showCertificateDelete && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>Are You Sure You want to delete Certificate?</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleRemoveCertificateClose();
                  }}
                />
              </div>

              <div className="text-center mt-2">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => removeCertificate()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )} */}
    </>
  );
};

export default ProfileCertificateUpdate;
